module.exports = __webpack_public_path__ + "img/step2-2.555aeecd.png";